export * from "./components/chat-float/chat-float";
export * from "./components/input-modal/input-modal";
export * from "./utils/dom-utils";

// Función de inicialización segura para frameworks como Astro
export const initializePromptEngine = () => {
  // Esta función se puede llamar para inicializar el componente de forma segura
  // en entornos SSR como Astro
  if (typeof window !== "undefined") {
    // El código se ejecutará solo en el navegador
    console.log("Prompt Engine inicializado en el navegador");
  }
};
